import Dashcard from "../DashCard";
import FormComp from "../FormsComp";


export const dadosFornecedores = (fornecedor) => {
    return [
        {
            titulo: 'Situação',
            valor: fornecedor?.ativo  === '1' ? 'Ativo' : 'Desativado',
            valorSelect: fornecedor?.ativo === '1' ? '1' : '0',
            name: 'ativo',
            tipo: 'Select',
            options: [{ id: '1', nome: 'Ativo' }, { id: '0', nome: 'Desativado' }]
        },
        {
            titulo: 'CNPJ *',
            valor: fornecedor?.cpf_cnpj || '',
            name: 'cpf_cnpj',
            tipo: 'Input',
            required: true,
            placeholder: 'Digite o CNPJ'
        },
        {
            titulo: 'Nome do Fornecedor *',
            valor: fornecedor?.nome || '',
            name: 'nome',
            tipo: 'Input',
            required: true,
            placeholder: 'Digite o nome do fornecedor'
        },
        {
            titulo: 'Telefone',
            valor: fornecedor?.telefone || '',
            name: 'telefone',
            tipo: 'Input',
            placeholder: 'Digite o telefone'
        },
        {
            titulo: 'Endereço',
            valor: fornecedor?.endereco || '',
            name: 'endereco',
            tipo: 'Input',
            placeholder: 'Digite o endereço'
        },
        {
            titulo: 'Número',
            valor: fornecedor?.numero || '',
            name: 'numero',
            tipo: 'Input',
            placeholder: 'Digite o número'
        },
        {
            titulo: 'Estado',
            valor: fornecedor?.estado || 'Nenhum dado cadastrado.',
            name: 'estado',
        },
        {
            titulo: 'Cidade',
            valor: fornecedor?.municipio || 'Nenhum dado cadastrado.',
            name: 'municipio',
        },

    ]
}

export const componentsMap = (closeModal, handleCancelClick, handleSaveClick, handleEditClick, handleInputChange) => {
    return {
        Geral: (dado) => <Dashcard titulo={dado.titulo} valor={dado.valor} />,
        Edit: (dado) => <FormComp dados={dado} handleInputChange={handleInputChange} />,
        buttonsEdit: () => (
            <>
                <button 
                    className='px-4 py-2 bg-gray-200 dark:bg-gray-600 text-gray-800 dark:text-gray-200 rounded-lg font-semibold hover:bg-gray-300 dark:hover:bg-gray-500 transition-colors duration-200' 
                    onClick={handleCancelClick}
                >
                    Cancelar
                </button>
                <button 
                    className='px-4 py-2 bg-vox-blue-600 hover:bg-vox-blue-700 text-white rounded-lg font-semibold transition-colors duration-200 shadow-vox hover:shadow-vox-lg' 
                    onClick={handleSaveClick}
                >
                    Salvar
                </button>
            </>
        ),
        buttonsGeral: () => (
            <>
                <button 
                    className='px-4 py-2 bg-gray-200 dark:bg-gray-600 text-gray-800 dark:text-gray-200 rounded-lg font-semibold hover:bg-gray-300 dark:hover:bg-gray-500 transition-colors duration-200' 
                    onClick={() => closeModal()}
                >
                    Fechar
                </button>
                <button 
                    className='px-4 py-2 bg-vox-blue-600 hover:bg-vox-blue-700 text-white rounded-lg font-semibold transition-colors duration-200 shadow-vox hover:shadow-vox-lg' 
                    onClick={handleEditClick}
                >
                    Editar
                </button>
            </>
        )
    }
}

export const cadastroComponentsMap = (handleInputChange) => {
    return {
        Cadastro: (dado) => <FormComp dados={dado} handleInputChange={handleInputChange} />,
    }
}